import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../../services/general.service';
import { DeadlineService } from '../../../../../services/deadline.service';
// import { DatepickerOptions } from 'ng2-datepicker';
import * as frLocale from 'date-fns/locale/fr';

import { DocumentMangService } from '../../../../../services/document_mang.service';
import { MedicalService } from '../../../../../services/medical.service';

declare var $: any;

@Component({
  selector: 'app-medical-examination-send-mail',
  templateUrl: './medical-eaxmination-send-mail.component.html',
  styleUrls: ['./medical-eaxmination-send-mail.component.css']
})


export class MedicalExaminationSendMailComponent implements OnInit {

  @Input() exam_id;  
  @Input() intervention_id; 
  @Input() ID;
  DID: string; action: string;
  
  @Input() langs: string;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  modalTitle: string;

  lang: any;
  actionLang: any;
  record: any;
  mode: string;
  app_emp_id: any;

  imageLink: any;
  general: any;
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  employee: any;
  cc: FormArray;
  senderMail:string
  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private deadlineService: DeadlineService,
    private documentmangService: DocumentMangService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private medicalService: MedicalService
  ) { }

  ngOnInit() {
    this.getData();
    this.FormBuild();
  }


  FormBuild(): void {
    this.createForm = this.formBuilder.group({
      mail_subject: ['', [Validators.required]],
      mail_sender: [''],
      send_to: ['', [Validators.required]],
      mail_notes: ['', [Validators.required]],
      mail_employees: ['', [Validators.required]],
      cc: this.formBuilder.array([this.createCC()]),
      exam_id:[this.ID],
      intervention_id:[this.intervention_id]

    });
  }

  createCC(){
    return this.formBuilder.group({
      email: [''] 
    })    
  }

  addEmail(){
    this.cc = this.createForm.get('cc') as FormArray;
    this.cc.push(this.createCC());    
  }

  removeEmail(i:number){
    this.cc.removeAt(i);
  }  


  onSubmit() {
    this.createFormSubmitted = true;
    if (this.createForm.invalid) {
      return;
    }
    
    this.medicalService.sendInterventionMail(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();
        }
        else {
          this.generalService.notify_msg('error', "Unable to send Mail");
          this.bsModalRef.hide();
        }
      },
      error => {
        this.generalService.notify_msg('error', "Unable to send Mail");
        this.bsModalRef.hide();        
      }

    );

  }

  getData() {
    this.medicalService.FetchDetails(this.ID)
      .subscribe(
        (res) => {
          this.lang = this.medicalService.GeneralGetLangData(res);
          this.general = res.data.general_data;
          this.employee = res.data.employee
          this.senderMail = res.data.mail_sender
        }
      );

  }

}
